import { LinearProgress } from "@mui/material";
import { FC } from "react";

interface FloatProgressBarProps {
  label: string;
  variant?: "blur" | "solid";
}

const FloatProgressBar: FC<FloatProgressBarProps> = ({ label, variant = "blur" }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 3000,
        backgroundColor: variant === "blur" ? "rgba(0, 0, 0, 0.3)" : "#ffffff",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          marginBottom: "8px",
          fontWeight: 600,
          color: variant === "blur" ? "#fff" : "#21212",
        }}
      >
        {label}
      </div>
      <LinearProgress style={{ width: "600px" }} />
    </div>
  );
};
export default FloatProgressBar;
